export enum GbAmtSearchMode {
  RECHTE_REGISTER_SEARCH,
  PUBLIKATIONS_REGISTER_SEARCH,
  GRUNDBUCHGESCHAEFT_SEARCH,
  GRUNDBUCHMELDUNG_REGISTER_SEARCH,
  GEOMETERGESCHAEFT_SEARCH
}
